import { Component, Input } from '@angular/core';

@Component({
    selector: '[card-inner]',
    template: `
        @if (helpText) {
            <div
                (mouseenter)="helpTextMouseenter()"
                class="pi-card_helpText"
                [hidden]="hovered"
            >
                <span>{{ helpText }}</span>
            </div>
        }
        <div class="pi-card_header">
            @if (title) {
                <div class="pi-card_header_title">
                    @if (titleLink) {
                        <a
                            [routerLink]="titleLink"
                            [queryParams]="titleLinkQueryParams"
                            class="lsg-link--dark"
                        >
                            {{ title }}
                        </a>
                    } @else {
                        <span>
                            {{ title }}
                            @if (titleTooltip) {
                                <i
                                    class="fa fa-question-circle"
                                    aria-hidden="true"
                                    tooltip
                                    [tooltipContent]="titleTooltip"
                                >
                                </i>
                            }
                        </span>
                    }
                </div>
            }
            <div class="pi-card_header_tools onlyShowIfIHaveChildren">
                <ng-content select="[cardTools]"></ng-content>
            </div>
        </div>
        <div
            class="pi-card_content slideShut"
            [ngClass]="{ 'slideShut--closed': !showMe }"
        >
            <ng-content select="[cardContent]"></ng-content>
        </div>
    `,
    standalone: false
})
export class CardInnerComponent {
    @Input()
    classes: string;
    @Input()
    title: string;
    @Input()
    titleTooltip: string;
    @Input()
    titleLink: string;
    @Input()
    titleLinkQueryParams: object;
    @Input()
    helpText: string;
    @Input()
    showMe = true;

    hovered = false;

    /**
     * The UX for this is that we want the help text to disappear when the user
     * mouses over the help text.
     *
     * Assumptions: turning it off on mouse enter THEN mouse leave will be a bad
     * interaction because the user will A) mouse over the text and then not
     * know how to make it disappear (until they move their mouse outside
     * accidentally) and B) having to mouse in and then mouse out of the help
     * text every time the page loads would be annoying
     */
    helpTextMouseenter() {
        this.hovered = true;
    }
}
